import React from 'react';
import PropTypes from 'prop-types';
import usePaging from '../../../../hooks/usePaging';
import { PAGING_SETTINGS } from '../../../../config/constant';
import NewsCard from '../../../../components/Card/NewsCard';

export default function NewsGrid({ news }) {
  const postsPerPage = PAGING_SETTINGS.POSTS_PER_PAGE;
  const [page, isLastPage, loadMorePage] = usePaging(
    'news',
    news.slice(1).length,
    postsPerPage
  );
  const featuredNews = news[0];
  const topNews = news
    .slice(1, postsPerPage * page + 1)
    .map(({ title, excerpt, dateGmt, uri, featuredImage }) => (
      <NewsCard
        key={title}
        title={title}
        featuredImage={featuredImage}
        excerpt={excerpt}
        uri={uri}
        dateGmt={dateGmt}
      />
    ));

  return (
    <div className="news-list">
      <div className="news-list__featured">
        <NewsCard
          key={featuredNews?.title}
          title={featuredNews?.title}
          featuredImage={featuredNews?.featuredImage}
          excerpt={featuredNews?.excerpt}
          uri={featuredNews?.uri}
          dateGmt={featuredNews?.dateGmt}
          type="horizontal"
        />
      </div>
      <div className="news-list__grid__wrapper">
        {topNews.length !== 0 && (
          <h3 className="news-list__grid__title">Top News</h3>
        )}
        <div className="news-list__grid">{topNews}</div>

        {!isLastPage && (
          <div className="news-list__grid__actions">
            <button
              className="load-more-btn"
              type="button"
              onClick={loadMorePage}
            >
              LOAD MORE
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

NewsGrid.propTypes = {
  news: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      excerpt: PropTypes.string,
      featuredImage: PropTypes.shape({}),
      uri: PropTypes.string,
      dateGmt: PropTypes.string,
      type: PropTypes.string
    })
  ).isRequired
};
